import { render, staticRenderFns } from "./driver.vue?vue&type=template&id=06b9443a&scoped=true&"
import script from "./driver.vue?vue&type=script&lang=js&"
export * from "./driver.vue?vue&type=script&lang=js&"
import style0 from "./driver.vue?vue&type=style&index=0&id=06b9443a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b9443a",
  null
  
)

export default component.exports